import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

const navItems = [
  { label: '平台特色', href: '#features' },
  { label: '热门专题', href: '#carousel' },
  { label: '读者热评', href: '#comments' },
  { label: '常见问题', href: '#faq' },
  { label: '精选视频', href: '#media' },
  { label: '关于我们', href: '#about' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header navItems={navItems} />

      <main>
        <Hero />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <CardsSection />
        <FaqSection />
        <AppSection />
        <CommentsSection />
        <TopicsSection />
        <MediaSection />
        <UpdatesSection />
        <AboutSection />
        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}